import { create } from "zustand";
import { useCuttingPlanStatsStore } from "./cuttingPlanStatsStore";
import {
    getTotalWeightExceptPreCutWaste,
    getTotalWasteWeightExceptPreCut,
    getTotalPreCutWeight,
    getOrderWeight,
    getOutageWeight,
    getSubstitutionWeight,
    getYieldPercentage,
    getWastePercentage,
    getYieldExceptPreCutPercentage,
    getWasteExceptPreCutPercentage,
    getNumberOfTotalLogs,
    getNumberOfOrderLogs,
    getTheoreticalWeight,
    getOrderWeightExceptPreCut
} from "../services/statistics/patternStatistics";

export const useCuttingPlanStore = create((set) => ({
    rebarInformation: {},
    setRebarInformation: (rebarInformation) => set({ rebarInformation }),

    logLength: 0,
    setLogLength: (logLength) => set({ logLength }),

    overlapRatio: 0,
    setOverlapRatio: (overlapRatio) => set({ overlapRatio }),

    allPatterns: [],
    setAllPatterns: (allPatterns) => set({ allPatterns }),
    allDiameters: [],
    setAllDiameters: (allDiameters) => set({ allDiameters }),
    allFloors: [],
    setAllFloors: (allFloors) => set({ allFloors }),

    makePatternPreCut: (patternNo) => {
        set((state) => ({
            allPatterns: state.allPatterns.map((pattern) => {
                if (pattern.patternNo === patternNo) {
                    return {
                        ...pattern,
                        preCut: true,
                    };
                }
                return pattern;
            }),
        }));
    },

    makePatternNotPreCut: (patternNo) => {
        set((state) => ({
            allPatterns: state.allPatterns.map((pattern) => {
                if (pattern.patternNo === patternNo) {
                    return {
                        ...pattern,
                        preCut: false,
                    };
                }
                return pattern;
            }),
        }));
    },

    removeAllPreCutPatterns: () => {
        set((state) => ({
            allPatterns: state.allPatterns.map((pattern) => ({
                ...pattern,
                preCut: false,
            })),
        }));
    },

    removeSelectedPreCutPatterns: () => {
        set((state) => ({
            allPatterns: state.allPatterns
                .map((pattern) => {
                    return pattern.show ?
                    {
                        ...pattern,
                        preCut: false,
                    } : pattern
                }),
        }));
    },

    currentPatterns: [],
    setCurrentPatterns: (currentPatterns) => set({ currentPatterns }),
    checkedDiameters: [],
    setCheckedDiameters: (checkedDiameters) => set({ checkedDiameters }),
    checkedFloors: [],
    setCheckedFloors: (checkedFloors) => set({ checkedFloors }),

    cuttingPlanInformation: {
        cpName: "",
        projectName: "",
        projectId: "",
        projectUser: "",
        floors: "",
        diameters: "",
        projectOverlapRatio: 0,
        minOutageLength: 0,
        solveFloorsSeparately: false,
        creationTime: "",
        totalExecutionTime: 0,
        diameterOptions: [],
    },
    setCuttingPlanInformation: (cuttingPlanInformation) => set({ cuttingPlanInformation }),

    rebarInformation: {}, // donatiDict
    setRebarInformation: (rebarInformation) => set({ rebarInformation }),

    overlapRatio: 1,
    setOverlapRatio: (overlapRatio) => set({ overlapRatio }),

    minOutageLength: 0,
    setMinOutageLength: (minOutageLength) => set({ minOutageLength }),

    showLowerFloorPatterns: true,
    setShowLowerFloorPatterns: (showLowerFloorPatterns) => set({ showLowerFloorPatterns }),

    projectActivated: false,
    setProjectActivated: (projectActivated) => set({ projectActivated }),

    projectCuttingPlanPermission: false,
    setProjectCuttingPlanPermission: (projectCuttingPlanPermission) => set({ projectCuttingPlanPermission }),
}));

useCuttingPlanStore.subscribe(
    (cuttingPlan) => {
        const patterns = cuttingPlan.allPatterns;
        const showedPatterns = patterns.filter(pattern => pattern.show);
        useCuttingPlanStatsStore.getState().setCuttingPlanStats({
            ...useCuttingPlanStatsStore.getState().cuttingPlanStats,
            totalWeight: getTotalWeightExceptPreCutWaste(showedPatterns),
            totalLogs: getNumberOfTotalLogs(showedPatterns),
            totalWasteWeight: getTotalWasteWeightExceptPreCut(showedPatterns),
            preCutWeight: getTotalPreCutWeight(showedPatterns),
            orderWeight: getOrderWeight(showedPatterns, cuttingPlan.checkedFloors),
            orderWeightExceptPreCut: getOrderWeightExceptPreCut(showedPatterns, cuttingPlan.checkedFloors),
            orderLogs: getNumberOfOrderLogs(showedPatterns, cuttingPlan.checkedFloors),
            outageWeight: getOutageWeight(showedPatterns, cuttingPlan.minOutageLength),
            subWeight: getSubstitutionWeight(showedPatterns),
            yieldPercentage: getYieldPercentage(showedPatterns),
            wastePercentage: getWastePercentage(showedPatterns),
            yieldExceptPreCutPercentage: getYieldExceptPreCutPercentage(showedPatterns),
            wasteExceptPreCutPercentage: getWasteExceptPreCutPercentage(showedPatterns),
            theoreticalWeight: getTheoreticalWeight(
                cuttingPlan.rebarInformation,
                cuttingPlan.allFloors,
                cuttingPlan.checkedDiameters,
                cuttingPlan.checkedFloors
            ),
        });
    },
    (state) => state.currentPatterns
);